export const SITES_TEMPLATE_BASE = {
    ECOM: "demo-ecommerce-base",
};

export const DYNAMIC_PAGE_TEMPLATES = {
    PRODUCT_OVERVIEW: "demo-ecommerce-base:pages/productOverview",
    PRODUCT_DETAIL: "demo-ecommerce-base:pages/productDetail",
};

export const PAGE_TEMPLATES = {
    STANDARD: "demo-ecommerce-base:pages/standard",
    HOME: "demo-ecommerce-base:pages/home",
    ...DYNAMIC_PAGE_TEMPLATES,
};

// Detail pages that live in the corporate/portal site picked as `contentSite` on the home page.
// Either module type can serve them, hence the lists.
export const CONTENT_SITE_PAGE_TEMPLATES = {
    BLOG_DETAIL: ["demo-ftl-portal:pages/blogDetail/blogDetail", "demo-ftl-corporate:pages/blogDetail/blogDetail"],
    EVENT_DETAIL: ["demo-ftl-portal:pages/eventDetail/eventDetail", "demo-ftl-corporate:pages/eventDetail/eventDetail"],
};

export const COMPONENT_TEMPLATES = {
    HERO: "demo-ecommerce-base:components/hero/hero",
    HERO_SLIDE: "demo-ecommerce-base:components/hero/heroSlide",
    HEADLINE: "demo-ecommerce-base:components/headline",
    IMAGE: "demo-ecommerce-base:components/image",
    GRID: "demo-ecommerce-base:components/grid",
    HTML: "demo-ecommerce-base:components/html",
    CARD_TEASER: "demo-ecommerce-base:components/cardTeaser",
    PRODUCT_TEASER: "demo-ecommerce-base:components/productTeaser",
    FORM: "demo-ecommerce-base:components/form",
    DOWNLOADS: "demo-ecommerce-base:components/downloads",
    VIDEO: "demo-ecommerce-base:components/video",
};
